var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinterest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pinterest_clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6641 24C19.2914 24 24.6639 18.6275 24.6639 12.0002C24.6639 5.37292 19.2914 0.000427246 12.6641 0.000427246C6.03679 0.000427246 0.664307 5.37292 0.664307 12.0002C0.664307 18.6275 6.03679 24 12.6641 24Z",
    fill: "#CB2027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6327 16.0692C12.7255 15.999 12.3443 15.5491 11.6329 15.1173C11.2418 17.1688 10.764 19.1355 9.34854 20.1629C8.9111 17.0621 9.98983 14.7331 10.4908 12.261C9.63688 10.8235 10.5935 7.93018 12.3946 8.64314C14.6113 9.51973 10.4754 13.988 13.2519 14.5461C16.1506 15.1288 17.3339 9.51652 15.5362 7.69104C12.939 5.05548 7.97611 7.63114 8.58638 11.404C8.73505 12.3264 9.68822 12.6064 8.96714 13.8792C7.30486 13.511 6.80903 12.2 6.87277 10.4522C6.97566 7.59114 9.44351 5.5879 11.9188 5.31067C15.0494 4.96029 17.9876 6.46021 18.3932 9.40486C18.8495 12.7283 16.9799 16.3276 13.6327 16.0692Z",
    fill: "#F1F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pinterest_clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.664062)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterest);
export default __webpack_public_path__ + "static/media/pinterest.043571aa2dec4394808f7029e860c873.svg";
export { ForwardRef as ReactComponent };